<script setup lang="ts">
import { useTheme } from '@/stores/theme';

const theme = useTheme();
</script>
<template>
  <wb-skeleton class="owpi-spa-tech-data" :theme="theme.wb" />
</template>
<style lang="scss" src="./SectionTechData.scss" />
<style lang="scss">
wb-skeleton.owpi-spa-tech-data {
  display: block;
  max-width: var(--wb-grid-width);
  margin-inline: auto;
}
</style>
